import React from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Challenge } from './2fa/challenge';
import { Setup } from './2fa/setup';
import AutoLogin from './auto-login';
import Help from './help';
import ChangePassword from './help/change-password';
import ResetSent from './help/reset-sent';
import Login from './login';
import { Logout } from './logout';
import NoUser from './no-user';
import VerifyEmail from './verify-email';
import './style.css';
import AuthStore from 'bz-stores/lib/auth-store';
import useAutorun from 'bz-utilities/hooks/autorun';
import useComputed from 'bz-utilities/hooks/computed';
import { observer } from 'mobx-react';
import { cache } from 'tm3-core/cache';

const LoginRouter = observer(() => {
  const location = useLocation();

  const appid = useComputed(() => {
    if (cache.isClick) return 'qqcol12v';
    return 'f8r88klr';
  }, [cache]);

  useAutorun(() => {
    if (localStorage.getItem('hideChat') == 'true') return;
    if (!cache.app.Caseflow && !cache.isProntoPortal) {
      const host = window.location.host;
      window.Intercom?.('shutdown');
      window.Intercom?.('boot', {
        app_id: appid,
        subdomain: host.substring(0, host.indexOf('.'))
      });
    }
  }, []);

  const { stage1Authenticated } = AuthStore;
  return (
    <TransitionGroup className="login-areas">
      <CSSTransition classNames="page" timeout={300} key={location.pathname}>
        <div className="login-content-area">
          <Switch location={location}>
            <Route
              path={[`/auto-login/:token/:redirectParam`, `/auto-login/:token`]}
              component={AutoLogin}
            />
            <Route path={[`/recover/:code`, `/recover/`]}>
              <ChangePassword resetPassword />
            </Route>
            <Route path={[`/verify/:code`, `/verify`]}>
              <ChangePassword setNewPassword />
            </Route>
            <Route path={`/email-verify/:code`}>
              <VerifyEmail />
            </Route>
            <Route path={`/login/help/sent`}>
              <ResetSent />
            </Route>
            <Route path={`/login/help`}>
              <Help />
            </Route>

            <Route path={`/login/mfa/challenge`}>
              {stage1Authenticated ? <Challenge /> : <Redirect to="/login" />}
            </Route>

            <Route path={`/login/mfa/setup`}>
              {stage1Authenticated ? <Setup /> : <Redirect to="/login" />}
            </Route>

            <Route path={`/no-user`}>
              <NoUser />
            </Route>
            <Route path={`/logout`}>
              <Logout />
            </Route>
            <Route path={`/login`}>
              <Login />
            </Route>
          </Switch>
        </div>
      </CSSTransition>
    </TransitionGroup>
  );
});

export { LoginRouter };

export const LoginRoutePaths = [
  `/login`,
  '/auto-login/:token',
  `/verify/:code`,
  `/verify`,
  `/email-verify/:code`,
  `/no-user`,
  `/recover/:code`,
  `/recover`,
  `/logout`
];
